import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import { Carousel } from 'react-responsive-carousel';
import imageAxios from '../../imageAxios'
const CentreImagesCarousel = ({ images }) => {
  return (
    <div className="flex flex-col row-span-2 md:col-span-3 col-span-2">
      <div className="text-gray-800 font-bold mb-2">Centre Images</div>
      {images?.length > 0 ? (
        <Carousel className="w-full" showThumbs={false} showStatus={false} infiniteLoop useKeyboardArrows autoPlay>
          {images.map((image, index) => (
            <div key={index}>
              <img
                className="h-96 w-full object-cover"
                src={`${imageAxios}/${image.path.replace(/\\/g, '/')}`}
                alt={`Centre Image ${index + 1}`}
                loading="lazy" // Lazy loading attribute
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <div className="text-gray-500">No images found</div>
      )}
    </div>
  );
};

export default CentreImagesCarousel;
